"use client";

import { useBusinessInfo } from "@/modules/hooks/business/business";
import { useNotification } from "@/modules/hooks/notification/useNotification";
import { memo, useEffect } from "react";

const NotificationProvider = memo(() => {
  const { loadUnreadNoti, loadAllNoti } = useNotification();
  const { businessInfo } = useBusinessInfo();

  useEffect(() => {
    if (businessInfo) {
      loadUnreadNoti();
      loadAllNoti();
    }
  }, [businessInfo]);

  return <></>;
});

NotificationProvider.displayName = "NotificationProvider";
export default NotificationProvider;
